import { useLang } from '@/i18n';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

interface ItfItem {
    name: string;
    text: string;
    img: [string, string];
    tip?: string;
}
const C: React.FC = () => {
    const { t } = useLang('stream.overview');
    const [enter, setEnter] = useState(false);
    const items: ItfItem[] = [
        {
            name: 'C_box1_name',
            text: 'C_box1_text',
            img: ['https://websiteoss.ecoflow.com/upload/image/1774593672399/c1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1774593673722/c1m.jpg'],
        },
        {
            name: 'C_box2_name',
            text: 'C_box2_text',
            img: ['https://websiteoss.ecoflow.com/upload/image/1774593673539/c2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1774593673337/c2m.jpg'],
        },
        {
            name: 'C_box3_name',
            text: 'C_box3_text',
            img: ['https://websiteoss.ecoflow.com/upload/image/1774593673127/c3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1774593672564/c3m.jpg'],
        },
        {
            name: 'C_box4_name',
            text: 'C_box4_text',
            tip: 'C_box4_tip',
            img: ['https://websiteoss.ecoflow.com/upload/image/1774593673006/c4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1774593672767/c4m.jpg'],
        },
    ];

    useOnceInView('.stream-nl-C .title', () => {
        document.querySelector('.stream-nl-C .title')?.classList.add('enter');
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: '.stream-nl-C .items',
                triggerHook: 1,
                offset: '10%',
                duration: '200%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
        }
    }, []);

    return (
        <div className={`${css.section} stream-nl-C GtmModuleData-section space`} id="stream-nl-C" data-section-id={'stream-nl-C'}>
            <div className="info">
                <h2 className="title ani-1">{t('C_title')}</h2>
            </div>
            <ul className={`items box ${enter ? 'enter' : ''}`}>
                {items?.map((item: ItfItem, i: number) => (
                    <li className={`item itme-${i + 1}`} key={item.name} style={{ gridArea: `a${i + 1}`, transitionDelay: enter ? `${i * 0.25}s` : '0s' }}>
                        <EcoImg className="item-img" pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} alt={t('C_title')} />
                        <div className="item-info">
                            <p className="item-name">{t(item.name)}</p>
                            <p className="item-text">
                                {t.rich(item.text, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                            {/* {item.tip && <p className="item-tip">{t(item.tip)}</p>} */}
                        </div>
                    </li>
                ))}
            </ul>
            <p className="box tip">{t('C_box4_tip')}</p>
        </div>
    );
};

export default C;
